// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-previewer-container {\n  width: 100vw;\n  height: 100%;\n}\n@media screen and (min-width: 769px) {\n.file-previewer-container.no-fullwidth {\n    width: 50vw;\n}\n}\n.row-container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n}\n.second-row {\n  flex-grow: 1;\n  border: none;\n  margin: 0;\n  padding: 0;\n  background-color: #FFF;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
